// extracted by mini-css-extract-plugin
module.exports = {"ModalWrapper":"CronJobs_ModalWrapper__17bba","label":"CronJobs_label__3ADB5","cronActionConatiner":"CronJobs_cronActionConatiner__3BHVl"};